import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { isNotStartedYet, SubmitInfo } from "../types";
import { isErrored } from "../types";

export const useModalActionButton = ({
  cancelInFlightUploads,
  isSubmitting,
  setIsSubmitting,
  submitInfo,
}: {
  cancelInFlightUploads: () => void;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
  submitInfo: SubmitInfo;
}) => {
  const { t } = useTranslation();
  const onCancelSubmit = useCallback(() => {
    cancelInFlightUploads();
    setIsSubmitting(false);
  }, [cancelInFlightUploads, setIsSubmitting]);

  const onCloseModal = useCallback(() => {
    setIsSubmitting(false);
  }, [setIsSubmitting]);

  const modalActionButton = [
    {
      label: t("AddBuilding.submitModal.action.cancel"),
      onClick: onCancelSubmit,
      show: isSubmitting && isNotStartedYet(submitInfo.buildingInfo?.status),
    },
    {
      label: t("AddBuilding.submitModal.action.close"),
      onClick: onCloseModal,
      show: isSubmitting && isErrored(submitInfo.buildingInfo?.status),
    },
  ];

  return {
    modalActionButton,
  };
};
